import commonText from './commonContents'


export default {
    ...commonText,
    "mobileValidityErrorText": "يرجى تقديم رقم هاتف محمول صالح للمتابعة",
    "backButtonText": "رجوع",
    "heading": "إجراءات التسجيل السريع",
    "subHeading": "التسجيل الإلكتروني سيعجل من عملية شراء منزلك.",
    "fasttrackCompletedTextOne": ".لقد تمت عملية تسجيلكم للخدمة السريعة بنجاح",
    "fasttrackCompletedTextTwo": ".ان فريقنا جاهز لجعل عملية شرائكم سهلة وفردية",
    "fasttrackCompletedTextThree": "ALDAR 800 (25327) إذا كانت لديكم أي استفسارات يرجى التواصل معنا على",
    "fasttrackIncompleteText": "فشل التسجيل الإلكتروني",
    "opportunityIdPrefix": "معرّف موعدك",
    "retryText": ".من فضلك, يرجى المحاولة مرة أخرى",
    "invalidLeadError": "الرابط الذي تحاول الوصول إليه يبدو غير صالح",
    "suggestionTextInvalidLead": "يرجى التواصل مع شركة الدار",
    "suggestionTextValidLead": "شركة الدار ستتواصل معك قريبا",
    "fastTrackError": "حدث خطأ، هل يمكنك المحاولة مرة أخرى من خلال التحقق من البيانات التي قدمتها؟",
    "alreadyConvertedLead": "الرابط الذي تحاول الوصول إليه يبدو أنه تم استخدامه بالفعل. يرجى التحقق من بريدك الإلكتروني للحصول على التأكيد.",
    "mandatoryDocumentsNotUploadedError": 'يرجى تحميل المستندات المطلوبة.',
    "residentStatusYesLabel": 'نعم',
    "residentStatusNoLabel": 'لا',
    "documentUploadCancelButtonText": "إلغاء",
    "valueLessThanPrefix": "يجب أن تكون القيمة أقل من",
    "valueGreaterThanPrefix": "يجب أن تكون القيمة أكبر من",
    "Fast Track reference is invalid. Please click on the email link to proceed.": "الحجز عبر الإنترنت وتسجيل الوصول غير صالح",
    "Your Fast Track has already been submitted successfully.": "لقد اكتمل الحجز عبر الإنترنت وتسجيل الوصول بالفعل",
    "docusignDoneStatus": "الآن بعد أن قمت بتوقيع المستندات، يمكنك تقديم طلبك.",
    "documentStepWarning": "يرجى مراجعة المعلومات المقدمة قبل المتابعة، حيث أنك لن تتمكن من إجراء أي تغييرات بعد الانتقال إلى الخطوة التالية. للمتابعة، يرجى النقر على زر التأكيد أدناه. للإلغاء، الرجاء الضغط على زر الإغلاق.",
    "continueButtonText": "تأكيد",
    "tabs": {
        "idVerification": {
            "id": '0',
            "tabLabel": "مسح المستندات",
            "iconUrl": "/du_incomplete.png",
            "heading": "مسح المستندات",
            "subHeadingPart1": "",
            "subHeadingPart1PostText": "",
            "continueButtonText": "التالي"
        },
        "personDetails": {
            "id": '1',
            "tabLabel": "تفاصيل شخصية",
            "iconUrl": "/pmdf_complete.png",
            "heading": "تفاصيل شخصية",
            "subHeading": "للانتقال إلى المرحلة التالية، يجب عليك ملء تفاصيلك الشخصية أولاً، وحفظها، ثم المتابعة لإدخال تفاصيل عنوانك",
            "subHeadingPart1": "للانتقال إلى المرحلة التالية، أدخل أولاً ",
            "subHeadingPart1PostText": "معلوماتك الشخصية،",
            "subHeadingPart2": "احفظها، ثم قدم ",
            "subHeadingPart2PostText": "تفاصيل العنوان",
            "fields": {
                "FirstName": {
                    type: 'text',
                    label: 'الاسم الاول',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    disabled: true,
                    condition: "isNameEditable",
                    valueKey: "FirstName",
                    maxLength: 40
                },
                "LastName": {
                    type: 'text',
                    label: 'اسم العائلة',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    disabled: true,
                    condition: "isNameEditable",
                    valueKey: "LastName",
                    maxLength: 80
                },
                "Placeofbirth__c": {
                    type: 'text',
                    label: 'مكان الولادة',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "Placeofbirth__c",
                    maxLength: 40
                },
                "PersonBirthdate": {
                    type: 'date',
                    label: 'تاريخ الميلاد',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    validationCheckOperator: '<',
                    validationCheckOperand: 'currentDate',
                    valueKey: "PersonBirthdate",
                    validationChecks: [
                        {
                            validationCheckOperator: '<',
                            validationCheckOperand: 'currentDate',
                            validationCheckOperandLabel: 'current date'
                        },
                    ]
                },
                "Gender__pc": {
                    type: 'select',
                    label: 'الجنس',
                    optionsSource: 'gender',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "Gender__pc"
                },
                "MaritalStatus__pc": {
                    type: 'select',
                    label: 'الحالة الاجتماعية',
                    optionsSource: 'maritalStatus',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "MaritalStatus__pc"
                },
                "MobileCountryCode__pc": {
                    type: 'select',
                    label: '',
                    optionsSource: 'mobileCountryCode',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "MobileCountryCode__pc"
                },
                "MobilePhone__pc": {
                    type: 'text',
                    label: 'رقم الجوال',
                    format: 'number',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    formatErrorMessage: commonText.formatErrorMessage,
                    valueKey: "MobilePhone__pc",
                    maxLength: 30
                },
                "PersonEmail": {
                    type: 'text',
                    label: 'البريد الإلكتروني',
                    format: 'email',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    formatErrorMessage: commonText.formatErrorMessage,
                    disabled: true,
                    valueKey: "PersonEmail",
                    maxLength: 80
                },
                "Nationality__pc": {
                    type: 'select',
                    label: 'الجنسية',
                    optionsSource: 'nationality',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "Nationality__pc"
                },
                "ResidentStatus__pc": {
                    type: 'radio',
                    label: 'هل أنت مقيم في دولة الإمارات العربية المتحدة؟',
                    optionsSource: 'residentStatus',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "ResidentStatus__pc"
                },
                "NationalIdNumber__pc": {
                    type: 'text',
                    label: 'رقم الهوية الإماراتية',
                    format: "number",
                    dependency: 'ResidentStatus__pc',
                    requiredCondition: 'Resident',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    formatErrorMessage: commonText.formatErrorMessage,
                    valueKey: "NationalIdNumber__pc",
                    maxLength: 16,
                    minLength: 15
                },
                "NationalIdExpiryDate__pc": {
                    type: 'date',
                    label: ' تاريخ انتهاء صلاحية الهوية الإماراتية',
                    dependency: 'ResidentStatus__pc',
                    requiredCondition: 'Resident',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    validationCheckOperator: '>',
                    validationCheckOperand: 'currentDate',
                    valueKey: "NationalIdExpiryDate__pc",
                    validationChecks: [
                        {
                            validationCheckOperator: '>',
                            validationCheckOperand: 'currentDate',
                            validationCheckOperandLabel: 'current date'
                        },
                        {
                            validationCheckOperator: '>',
                            validationCheckOperand: 'PersonBirthdate',
                            validationCheckOperandLabel: 'person birthdate'
                        }
                    ]
                },
                "PassportType__pc": {
                    type: 'text',
                    label: 'نوع جواز السفر',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "PassportType__pc",
                    maxLength: 20
                },
                "PlaceofIssue__pc": {
                    type: 'text',
                    label: 'مكان إصدار الجواز',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "PlaceofIssue__pc",
                    maxLength: 40
                },
                "PassportIssueDate__pc": {
                    type: 'date',
                    label: 'تاريخ إصدار الجواز',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "PassportIssueDate__pc",
                    validationChecks: [
                        {
                            validationCheckOperator: '<',
                            validationCheckOperand: 'PassportExpiryDate__pc',
                            validationCheckOperandLabel: 'passport expiry date'
                        },
                        {
                            validationCheckOperator: '<',
                            validationCheckOperand: 'currentDate',
                            validationCheckOperandLabel: 'current date'
                        },
                        {
                            validationCheckOperator: '>',
                            validationCheckOperand: 'PersonBirthdate',
                            validationCheckOperandLabel: 'person birthdate'
                        },

                    ]
                },

                "PassportExpiryDate__pc": {
                    type: 'date',
                    label: 'تاريخ انتهاء صلاحية الجواز',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    validationCheckOperator: '>',
                    validationCheckOperand: 'passportIssueDate',
                    valueKey: "PassportExpiryDate__pc",
                    validationChecks: [
                        {
                            validationCheckOperator: '>',
                            validationCheckOperand: 'PassportIssueDate__pc',
                            validationCheckOperandLabel: 'passport issue date'
                        },
                        {
                            validationCheckOperator: '>',
                            validationCheckOperand: 'currentDate',
                            validationCheckOperandLabel: 'current date'
                        },
                        {
                            validationCheckOperator: '>',
                            validationCheckOperand: 'PersonBirthdate',
                            validationCheckOperandLabel: 'person birthdate'
                        }
                    ]
                },
                "PassportNumber__pc": {
                    type: 'text',
                    label: 'رقم جواز السفر',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "PassportNumber__pc",
                    format: "alphaNum",
                    maxLength: 20
                },
                "CountryOfResidence__pc": {
                    type: 'select',
                    label: 'بلد الإقامة',
                    optionsSource: 'country',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "CountryOfResidence__pc",
                    dependency: 'ResidentStatus__pc',
                    requiredCondition: 'Non-Resident',
                }                
            },
            "continueButtonText": "التالي"
        },
        "addressDetails": {
            "id": '2',
            "tabLabel": "تفاصيل العنوان",
            "iconUrl": "/adf_incomplete.png",
            "heading": "تفاصيل العنوان",
            "subHeading": "للانتقال إلى المرحلة التالية، يجب عليك أولاً ملء تفاصيل عنوانك، وحفظها، ثم الانتقال إلى إدخال تفاصيل ثروتك",
            "subHeadingPart1": "للانتقال إلى المرحلة التالية، يجب عليك أولاً ملء ",
            "subHeadingPart1PostText": "تفاصيل العنوان، ",
            "subHeadingPart2": "احفظها، ثم تابع لإدخال ",
            "subHeadingPart2PostText": "تفاصيل الثروة","ResidentialAddressSameAsPermanent__cYes": "نعم",
            "ResidentialAddressSameAsPermanent__cNo": "لا",
            "fields": {
                "BillingAddressHeading":{
                    type: 'label',
                    optional: true,
                    label: "تفاصيل عنوان السكن الدائم"// pending
                },
                "BillingCountry": {
                    type: 'select',
                    label: 'الدولة',
                    optionsSource: 'country', // billingCountry
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "BillingCountry"
                },                
                "BillingState": {
                    type: 'select',
                    label: 'الولاية/المحافظة',
                    requiredErrorMessage: commonText.requiredErrorMessage, //billingState
                    valueKey: "BillingState",
                    optional: true,
                    optionsSource: 'state',
                },
                "BillingStreet": {
                    type: 'text',
                    label: 'عنوان السكن',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "BillingStreet",
                    maxLength: 255
                },
                "BillingCity": {
                    type: 'text',
                    label: 'مدينة',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "BillingCity",
                    maxLength: 40
                },
                "BillingPostalCode": {
                    type: 'text',
                    label: 'الرمز البريدي ',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    formatErrorMessage: commonText.formatErrorMessage,
                    valueKey: "BillingPostalCode",
                    optional: true,
                    format: "alphaNum",
                    maxLength: 20
                },
                "ResidentialAddressSameAsPermanent__c": {
                    type: 'radio',
                    label: 'هل العنوان الحالي هو نفسه العنوان الدائم؟',// pending
                    optionsSource: ['Yes', 'No'],
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "ResidentialAddressSameAsPermanent__c"
                },
                "ShippingAddressHeading": {
                    type: 'label',
                    optional: true,
                    label: "تفاصيل عنوان السكن الحالي",// pending
                    dependency: 'ResidentialAddressSameAsPermanent__c',
                    requiredCondition: 'No',
                },
                "ShippingCountry": {
                    type: 'select',
                    label: 'الدولة',
                    dependency: 'ResidentialAddressSameAsPermanent__c',
                    requiredCondition: 'No',
                    optionsSource: 'country', // ShippingCountry
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "ShippingCountry"
                },                
                "ShippingState": {
                    type: 'select',
                    label: 'الولاية/المحافظة',
                    dependency: 'ResidentialAddressSameAsPermanent__c',
                    requiredCondition: 'No',
                    requiredErrorMessage: commonText.requiredErrorMessage, //ShippingState
                    valueKey: "ShippingState",
                    optional: true,
                    optionsSource: 'state',
                },
                "ShippingStreet": {
                    type: 'text',
                    label: 'عنوان السكن',
                    dependency: 'ResidentialAddressSameAsPermanent__c',
                    requiredCondition: 'No',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "ShippingStreet",
                    maxLength: 255
                },
                "ShippingCity": {
                    type: 'text',
                    label: 'مدينة',
                    dependency: 'ResidentialAddressSameAsPermanent__c',
                    requiredCondition: 'No',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "ShippingCity",
                    maxLength: 40
                },
                "ShippingPostalCode": {
                    type: 'text',
                    label: 'الرمز البريدي ',
                    dependency: 'ResidentialAddressSameAsPermanent__c',
                    requiredCondition: 'No',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    formatErrorMessage: commonText.formatErrorMessage,
                    valueKey: "ShippingPostalCode",
                    optional: true,
                    format: "alphaNum",
                    maxLength: 20
                }
            },
            "continueButtonText": "التالي"
        },
        "employmentDetails": {
            "id": '3',
            "tabLabel": "تفاصيل الثروة",
            "iconUrl": "/edf_incomplete.png",
            "heading": "تفاصيل العمل",
            "subHeading": "للانتقال إلى المرحلة التالية، يجب عليك أولاً ملء تفاصيل ثروتك، وحفظها، ثم الانتقال إلى التحقق وتوقيع مستنداتك",
            "subHeadingPart1": "للانتقال إلى المرحلة التالية، يجب عليك أولاً ملء ",
            "subHeadingPart1PostText": "تفاصيل الثروة، ",
            "subHeadingPart2": "احفظها، ثم تابع لـ ",
            "subHeadingPart2PostText": "تحميل مستنداتك",
            "fields": {
                EmploymentStatus__pc: {
                    type: 'select',
                    label: 'الحالة الوظيفية',
                    optionsSource: 'employmentStatus',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "EmploymentStatus__pc"
                },
                Company__pc: {
                    type: 'text',
                    label: 'اسم الشركة',
                    dependency: 'EmploymentStatus__pc',
                    requiredCondition: 'Employed|Self Employed|Investor|Retired',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "Company__pc",
                    maxLength: 60
                },
                Position__pc: {
                    type: 'text',
                    label: 'المنصب الوظيفي ',
                    dependency: 'EmploymentStatus__pc',
                    requiredCondition: 'Employed|Self Employed|Investor|Retired',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "Position__pc",
                    maxLength: 100
                },
                CompanyAddress__pc: {
                    type: 'text',
                    label: 'عنوان الشركة',
                    dependency: 'EmploymentStatus__pc',
                    requiredCondition: 'Employed|Self Employed|Investor|Retired',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "CompanyAddress__pc",
                    maxLength: 255
                },
                AnnualIncome__pc: {
                    type: 'text',
                    label: 'الدخل السنوي',
                    dependency: 'EmploymentStatus__pc',
                    requiredCondition: 'Employed|Self Employed|Investor|Inheritance|Retired|Unemployed|House-Wife',
                    secondaryDependency: 'SourceofFunds__pc',
                    secondaryRequiredCondition: 'Unemployed.Savings/Retirement Income|House-Wife.Savings/Retirement Income',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    formatErrorMessage: commonText.formatErrorMessage,
                    valueKey: "AnnualIncome__pc",
                    format: "number",
                    maxLength: 16
                },
                NoofYearswithCompany__pc: {
                    type: 'text',
                    label: 'عدد سنوات العمل في الشركة',
                    dependency: 'EmploymentStatus__pc',
                    requiredCondition: 'Employed|Self Employed|Investor|Retired',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    formatErrorMessage: commonText.formatErrorMessage,
                    valueKey: "NoofYearswithCompany__pc",
                    format: "number",
                    maxLength: 2
                },
                Industry: {
                    type: 'select',
                    label: 'القطاع الصناعي',
                    dependency: 'EmploymentStatus__pc',
                    requiredCondition: 'Employed|Self Employed|Investor|Retired',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "Industry",
                    optionsSource: 'industry',
                },
                SourceofFunds__pc: {
                    type: 'select',
                    label: 'مصدر الأموال',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "SourceofFunds__pc",
                    optionsSource: 'sourceofFunds',
                },
                "AdditionalFieldsHeading":{
                    type: 'label',
                    optional: true,
                    label: "Additional Information"
                },
                "CustomerBankName__c": {
                    type: 'text',
                    label: 'اسم البنك للأموال',
                    dependency: 'EmploymentStatus__pc',
                    requiredCondition: 'Employed|Self Employed|Investor|Inheritance|Retired|Unemployed|House-Wife',
                    secondaryDependency: 'SourceofFunds__pc',
                    secondaryRequiredCondition: 'Unemployed.Savings/Retirement Income|House-Wife.Savings/Retirement Income',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "CustomerBankName__c",
                    formatErrorMessage: commonText.formatErrorMessage,
                    maxLength: 255
                },
                "CustomerBankCountry__c": {
                    type: 'select',
                    label: 'بلد البنك',
                    optionsSource: 'country',
                    dependency: 'EmploymentStatus__pc',
                    requiredCondition: 'Employed|Self Employed|Investor|Inheritance|Retired|Unemployed|House-Wife',
                    secondaryDependency: 'SourceofFunds__pc',
                    secondaryRequiredCondition: 'Unemployed.Savings/Retirement Income|House-Wife.Savings/Retirement Income',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "CustomerBankCountry__c"
                },
                NumberOfUnits__c: {
                    type: 'text',
                    label: 'عدد الوحدات',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "NumberOfUnits__c",
                    formatErrorMessage: commonText.formatErrorMessage,
                    format: "number",
                    maxLength: 2
                },
                EstimatedPurchaseValue__c: {
                    type: 'text',
                    label: 'القيمة المقدرة للشراء',
                    requiredErrorMessage: commonText.requiredErrorMessage,
                    valueKey: "EstimatedPurchaseValue__c",
                    formatErrorMessage: commonText.formatErrorMessage,
                    format: "number",
                    maxLength: 16
                },
            },
            "continueButtonText": "التالي"

        },
        "uploadDocuments": {
            "id": '4',
            "tabLabel": "تحميل المستندات",
            "iconUrl": "/du_incomplete.png",
            "heading": "تحميل المستندات",
            "subHeading": 'للانتقال إلى المرحلة التالية، يجب أن تقوم أولاً بتحميل مستنداتك، ثم المتابعة لتوقيع الوثائق المطلوبة.',
            "subHeadingPart1": "للانتقال إلى المرحلة التالية، يجب عليك أولاً تحميل",
            "subHeadingPart1PostText": " مستنداتك",
            "subHeadingPart2": ", ثم تابع لإكمال ",
            "subHeadingPart2PostText": "توقيع المستندات المطلوبة.",
            "documents": {
                "label": "أرفق المستندات التالية",
                "exclusionList": [
                    "KYC Form",
                    "Signed KYC Form",
                    "Wealth Form",
                    "Signed Wealth Form",
                    "ICA Verification"
                ],
                labelMapping: {
                    "ICA Verification": "التحقق من الهوية والجنسية من قبل ICA",
                    "KYC Form": "نموذج KYC",
                    "National ID Back Copy": "الجهة الخلفية للهوية الوطنية",
                    "National ID Front Copy": "الجهة الأمامية للهوية الوطنية",
                    "Others": "أخرى",
                    "Passport Copy": "صورة عن جواز السفر",
                    "Salary Certificate": "شهادة الراتب",
                    "Signed KYC Form": "نموذج KYC الموقع",
                    "VISA Copy": "صورة عن الفيزا",
                    "Trade License": "رخصة تجارية"
                }
            },
            "mandatoryDocuments": {
                "National ID Back Copy": {
                    label: "National ID Back Copy",
                    dependency: "ResidentStatus__pc",
                    dependancyValue: "Resident",
                },
                "National ID Front Copy": {
                    label: "National ID Front Copy",
                    dependency: "ResidentStatus__pc",
                    dependancyValue: "Resident",
                },
                "Passport Copy": {
                    label: "Passport Copy",
                },
                "VISA Copy": {
                    label: "VISA Copy",
                    dependency: "ResidentStatus__pc",
                    dependancyValue: "Resident",
                    negativeDependency: "Nationality__pc",
                    negativeDependencyValue: "United Arab Emirates"
                },                
                "Trade License": {
                    label: "Trade License",
                    dependency: "EmploymentStatus__pc",
                    dependancyValue: "Self Employed",
                }
            },
            "continueButtonText": "التالي"

        },
        "wealthDetails": {
            "investorDocument": {
                "title": "وثيقة المستثمر",
                "description": "الرجاء تحميل وثيقة تثبت وضعك كمستثمر",
                "requiredError": "يجب تحميل وثيقة المستثمر"
            },
           "freelancerDocument": {
               "title": "مستند العمل الحر",
               "description": "يرجى تحميل مستند يثبت حالتك كعامل مستقل",
               "requiredError": "مستند العمل الحر مطلوب. يرجى تحميل مستند للتحقق من حالتك كعامل مستقل.",
            },
           "otherSourceRequired":{
               "otherSourceRequired":"يرجى اختيار مصدر واحد على الأقل للأموال."
            }   
        },
        "signDocuments": {
            "id": '6',
            "tabLabel": "توقيع المستندات",
            "iconUrl": "/sdf_incomplete.png",
            "heading": "توقيع المستندات",
            "subHeading": "للمتابعة، من الضروري التحقق وتوقيع المستندات.",
            "subHeadingPart1": "للمتابعة، من الضروري عليك ",
            "subHeadingPart1PostText": "التحقق وتوقيع مستنداتك.",
            "continueButtonText": "التالي"
        },
        "livenessCheck": {
            "id": "5",
            "tabLabel": "",
            "iconUrl": "/du_incomplete.png",
            "heading": "",
            "subHeadingPart1": "",
            "subHeadingPart1PostText": "",
            "continueButtonText": "Next"
        }
    },
    "documentUpload": {
        "addDocuments": "رفع مستند",
        "uploading": "جاري الرفع...",
        "loading": "جاري التحميل...",
        "uploadSuccess": "تم رفع المستند بنجاح",
        "uploadFailed": "فشل الرفع. يرجى المحاولة مرة أخرى.",
        "dropActive": "اسحب الملفات هنا...",
        "invalidFileType": "نوع الملف غير صالح. الأنواع المسموح بها: {formats}",
        "fileSizeExceeded": "حجم الملف يتجاوز الحد المسموح به {size} ميجابايت.",
        "maxDocumentsExceeded": "الحد الأقصى {count} مستندات مسموح بها"
    }
}
